import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Image, Row } from "react-bootstrap";
import { ITeacher, SubjectKind } from "common/types";
import Spinner from "../../spinner";
import api from "common/api";
import usePageTitle from "common/usePageTitle";
import { s3_url } from "common/constants";

interface TeacherPageProps {
  kind?: SubjectKind;
}

function TeacherPage({ kind }: TeacherPageProps) {
  const [teachers, setTeachers] = useState<ITeacher[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  usePageTitle("Nastavnici");

  useEffect(() => {
    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const response = await api.get("/teachers/");
        let filteredTeachers = response.data;

        if (kind === SubjectKind.LESSON) {
          filteredTeachers = response.data.filter(
            (teacher: any) =>
              teacher.lesson_profile?.subjects &&
              teacher.lesson_profile.subjects.length > 0,
          );
        } else if (kind) {
          filteredTeachers = response.data.filter(
            (teacher: any) => teacher.profile != null,
          );
        }

        setTeachers(filteredTeachers);
      } catch (error) {
        console.log("error");
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, [kind]);

  return (
    <Row>
      <h1>Nastavnici</h1>

      <hr />

      {loading ? (
        <Spinner />
      ) : (
        <Container>
          {kind === SubjectKind.LESSON && (
            <Row>
              {teachers.map((teacher) => {
                const profileData = teacher.lesson_profile;

                if (profileData.hidden) {
                  return;
                }

                return (
                  <Col
                    key={teacher.user_id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className="mb-4"
                  >
                    <div className="text-center mb-2">
                      <Image
                        src={
                          profileData?.picture ||
                          `${s3_url}/img/lumenko/lumenko.webp`
                        }
                        alt={teacher.first_name}
                        style={{
                          width: "120px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center">
                      <h3>{teacher.first_name}</h3>
                      {profileData?.subjects &&
                        profileData.subjects.length > 0 && (
                          <div className="mt-2">
                            {profileData.subjects.map(
                              (subject: any, index: number) => (
                                <Badge
                                  key={index}
                                  bg="primary"
                                  className="me-1 mb-1"
                                >
                                  {subject.name}
                                </Badge>
                              ),
                            )}
                          </div>
                        )}
                      <p>{profileData?.remark}</p>
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}

          {kind === SubjectKind.PREPARATION &&
            teachers.map((teacher) => {
              const profileData = teacher.profile;

              return (
                <Row key={teacher.user_id} className="mb-3">
                  <Col xs="auto">
                    <Image
                      src={
                        profileData?.picture ||
                        `${s3_url}/img/lumenko/lumenko.webp`
                      }
                      alt={teacher.first_name}
                      style={{
                        width:
                          kind === SubjectKind.PREPARATION ? "250px" : "150px",
                        height: "auto",
                        borderRadius: "10px",
                      }}
                      loading="lazy"
                    />
                  </Col>
                  <Col className="pt-3 px-4">
                    <h2>
                      {teacher.first_name} {teacher.last_name}
                      {teacher.profile != null
                        ? `, ${teacher.profile?.title}`
                        : null}
                    </h2>
                    <p>{profileData?.remark}</p>
                  </Col>
                </Row>
              );
            })}
        </Container>
      )}
    </Row>
  );
}

export default TeacherPage;
